import BaseModel from './base_model';
import genderNeutralRestroomPopup from '../templates/popups/gender_neutral_restroom';

export default class GenderNeutralRestroom extends BaseModel {
	/**
	 * Represents a GenderNeutralRestroom linked to the server API.
	 * @constructor
	 * @param {integer} id - The id of the Rails GenderNeutralRestroom.
	 */
	constructor(id) {
		super();
		this.id = id;
		this.url = W.api_root + 'gender_neutral_restrooms' + '/' + id + '.json';
		this.key = 'GenderNeutralRestroom_' + id;
		this.object_type = 'gender_neutral_restrooms';
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'map_objects/' + this.data.map_object.id + '.html';
	}

	popupContent() {
		this.setHtmlView();
		return genderNeutralRestroomPopup(this);
	}
}
